import React from "react";
import Footer from "../layout/Footer";
import Header from "../layout/Header";

const Debuginput = (props) => {
  
  return (
    <div id="page">
      <Header />
      <Footer />
      <div className="page-content header-clear-medium">
        <div className="card card-style contact-form">
          <div className="content">
            <form
              action="php/contact.htm"
              method="post"
              className="contactForm"
              id="contactForm"
            >
              <fieldset>
                <div className="row">
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-name">
                      <label
                        className="contactNameField color-theme"
                        htmlFor="contactNameField"
                      >
                        Direction:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="direction"
                        name="direction"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.direction}
                        onChange={props.updatedimension}
                        
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label
                        className="contactEmailField color-theme"
                        htmlFor="contactEmailField"
                      >
                        Width at Invert:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="width"
                        name="width"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.width}
                        onChange={props.updatedimension}
                        
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label
                        className="contactEmailField color-theme"
                        htmlFor="contactEmailField"
                      >
                        Width at SPL:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="widthspl"
                        name="widthspl"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.widthspl}
                        onChange={props.updatedimension}
                        
                      />
                    </div>
                  </div>  
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label
                        className="contactHeightField color-theme"
                        htmlFor="contactHeightField"
                      >
                      Tunnel Height:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="height"
                        name="height"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.height}
                        onChange={props.updatedimension}
                        
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label
                        className="contactHeightField color-theme"
                        htmlFor="contactHeightField"
                      >
                        Wall Height:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="hw"
                        name="hw"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.hw}
                        onChange={props.updatedimension}
                        
                      />
                    </div>
                  </div>     
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label
                        className="contactHeightField color-theme"
                        htmlFor="contactHeightField"
                      >
                        Start Chainage (m) of Tunnel:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="startrd"
                        name="startrd"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.startrd}
                        onChange={props.updatedimension}
                        
                      />
                    </div>
                  </div>     
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label
                        className="contactHeightField color-theme"
                        htmlFor="contactHeightField"
                      >
                        End Chainage (m) of Tunnel:
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="endrd"
                        name="endrd"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.endrd}
                        onChange={props.updatedimension}
                        
                      />
                    </div>
                  </div>     
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label
                        className="contactHeightField color-theme"
                        htmlFor="contactHeightField"
                      >
                        P2
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="amt"
                        name="p2"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.p2}
                        onChange={props.updatedimension}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label
                        className="contactHeightField color-theme"
                        htmlFor="contactHeightField"
                      >
                       P4
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="rd"
                        name="p4"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.p4}
                        onChange={props.updatedimension}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="form-field form-email">
                      <label
                        className="contactHeightField color-theme"
                        htmlFor="contactHeightField"
                      >
                       P5
                      </label>
                      <input
                        type="text"
                        className="round-small"
                        id="rd"
                        name="p5"
                        aria-describedby="basic-addon3"
                        value={props.dimensions.p5}
                        onChange={props.updatedimension}
                      />
                    </div>
                  </div> 

                </div>                
                <div className="form-button">
                  <input
                    type="button"
                    className="btn bg-green-dark text-uppercase font-900 btn-m btn-full rounded-sm  shadow-xl contactSubmitButton"
                    value={props.label}
                    onClick={()=>{props.showoutput()}}
                  />
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Debuginput;
